import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["request"];
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// pkg/dist-src/index.js
import { getUserAgent } from "universal-user-agent";
import { request as octokitRequest } from "@octokit/request"; // pkg/dist-src/get-oauth-access-token.js

import { createDeviceCode, exchangeDeviceCode } from "@octokit/oauth-methods";

function getOAuthAccessToken(_x, _x2) {
  return _getOAuthAccessToken.apply(this, arguments);
}

function _getOAuthAccessToken() {
  _getOAuthAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, options) {
    var cachedAuthentication, _yield$createDeviceCo, verification, authentication;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cachedAuthentication = getCachedAuthentication(state, options.auth);

            if (!cachedAuthentication) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", cachedAuthentication);

          case 3:
            _context.next = 5;
            return createDeviceCode({
              clientType: state.clientType,
              clientId: state.clientId,
              request: options.request || state.request,
              // @ts-expect-error the extra code to make TS happy is not worth it
              scopes: options.auth.scopes || state.scopes
            });

          case 5:
            _yield$createDeviceCo = _context.sent;
            verification = _yield$createDeviceCo.data;
            _context.next = 9;
            return state.onVerification(verification);

          case 9:
            _context.next = 11;
            return waitForAccessToken(options.request || state.request, state.clientId, state.clientType, verification);

          case 11:
            authentication = _context.sent;
            state.authentication = authentication;
            return _context.abrupt("return", authentication);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getOAuthAccessToken.apply(this, arguments);
}

function getCachedAuthentication(state, auth2) {
  if (auth2.refresh === true) return false;
  if (!state.authentication) return false;

  if (state.clientType === "github-app") {
    return state.authentication;
  }

  var authentication = state.authentication;
  var newScope = ("scopes" in auth2 && auth2.scopes || state.scopes).join(" ");
  var currentScope = authentication.scopes.join(" ");
  return newScope === currentScope ? authentication : false;
}

function wait(_x3) {
  return _wait.apply(this, arguments);
}

function _wait() {
  _wait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(seconds) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, seconds * 1e3);
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _wait.apply(this, arguments);
}

function waitForAccessToken(_x4, _x5, _x6, _x7) {
  return _waitForAccessToken.apply(this, arguments);
} // pkg/dist-src/auth.js


function _waitForAccessToken() {
  _waitForAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request, clientId, clientType, verification) {
    var options, _ref, authentication, errorType;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            options = {
              clientId: clientId,
              request: request,
              code: verification.device_code
            };

            if (!(clientType === "oauth-app")) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return exchangeDeviceCode(_objectSpread(_objectSpread({}, options), {}, {
              clientType: "oauth-app"
            }));

          case 5:
            _context3.t0 = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.next = 10;
            return exchangeDeviceCode(_objectSpread(_objectSpread({}, options), {}, {
              clientType: "github-app"
            }));

          case 10:
            _context3.t0 = _context3.sent;

          case 11:
            _ref = _context3.t0;
            authentication = _ref.authentication;
            return _context3.abrupt("return", _objectSpread({
              type: "token",
              tokenType: "oauth"
            }, authentication));

          case 16:
            _context3.prev = 16;
            _context3.t1 = _context3["catch"](0);

            if (_context3.t1.response) {
              _context3.next = 20;
              break;
            }

            throw _context3.t1;

          case 20:
            errorType = _context3.t1.response.data.error;

            if (!(errorType === "authorization_pending")) {
              _context3.next = 25;
              break;
            }

            _context3.next = 24;
            return wait(verification.interval);

          case 24:
            return _context3.abrupt("return", waitForAccessToken(request, clientId, clientType, verification));

          case 25:
            if (!(errorType === "slow_down")) {
              _context3.next = 29;
              break;
            }

            _context3.next = 28;
            return wait(verification.interval + 5);

          case 28:
            return _context3.abrupt("return", waitForAccessToken(request, clientId, clientType, verification));

          case 29:
            throw _context3.t1;

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 16]]);
  }));
  return _waitForAccessToken.apply(this, arguments);
}

function auth(_x8, _x9) {
  return _auth.apply(this, arguments);
} // pkg/dist-src/hook.js


function _auth() {
  _auth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(state, authOptions) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getOAuthAccessToken(state, {
              auth: authOptions
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _auth.apply(this, arguments);
}

function hook(_x10, _x11, _x12, _x13) {
  return _hook.apply(this, arguments);
} // pkg/dist-src/version.js


function _hook() {
  _hook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(state, request, route, parameters) {
    var endpoint, _yield$getOAuthAccess, token;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            endpoint = request.endpoint.merge(route, parameters);

            if (!/\/login\/(oauth\/access_token|device\/code)$/.test(endpoint.url)) {
              _context5.next = 3;
              break;
            }

            return _context5.abrupt("return", request(endpoint));

          case 3:
            _context5.next = 5;
            return getOAuthAccessToken(state, {
              request: request,
              auth: {
                type: "oauth"
              }
            });

          case 5:
            _yield$getOAuthAccess = _context5.sent;
            token = _yield$getOAuthAccess.token;
            endpoint.headers.authorization = "token ".concat(token);
            return _context5.abrupt("return", request(endpoint));

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _hook.apply(this, arguments);
}

var VERSION = "6.0.1"; // pkg/dist-src/index.js

function createOAuthDeviceAuth(options) {
  var requestWithDefaults = options.request || octokitRequest.defaults({
    headers: {
      "user-agent": "octokit-auth-oauth-device.js/".concat(VERSION, " ").concat(getUserAgent())
    }
  });

  var _options$request = options.request,
      request = _options$request === void 0 ? requestWithDefaults : _options$request,
      otherOptions = _objectWithoutProperties(options, _excluded);

  var state = options.clientType === "github-app" ? _objectSpread(_objectSpread({}, otherOptions), {}, {
    clientType: "github-app",
    request: request
  }) : _objectSpread(_objectSpread({}, otherOptions), {}, {
    clientType: "oauth-app",
    request: request,
    scopes: options.scopes || []
  });

  if (!options.clientId) {
    throw new Error('[@octokit/auth-oauth-device] "clientId" option must be set (https://github.com/octokit/auth-oauth-device.js#usage)');
  }

  if (!options.onVerification) {
    throw new Error('[@octokit/auth-oauth-device] "onVerification" option must be a function (https://github.com/octokit/auth-oauth-device.js#usage)');
  }

  return Object.assign(auth.bind(null, state), {
    hook: hook.bind(null, state)
  });
}

export { createOAuthDeviceAuth };